import { Popover } from 'antd'
import styled from 'styled-components'

// TODO: create a component for Ant Design Popover and Storybook PORT-2311
export const StyledAntPopover = styled(Popover)``
